import React, { useState, useRef, useEffect } from "react";
import { Modal, Button, Slider, Icon } from "antd";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";

const ImageCropperModal = ({ visible, onCancel, onSave, imageSrc }) => {
  const [crop, setCrop] = useState({ unit: "%", width: 80, aspect: 1 });
  const [completedCrop, setCompletedCrop] = useState(null);
  const imgRef = useRef(null);

  const onLoad = (img) => {
    imgRef.current = img;
  };

  const generateCroppedImage = async () => {
    if (!completedCrop || !imgRef.current) return;

    const canvas = document.createElement("canvas");
    const scaleX = imgRef.current.naturalWidth / imgRef.current.width;
    const scaleY = imgRef.current.naturalHeight / imgRef.current.height;
    canvas.width = completedCrop.width;
    canvas.height = completedCrop.height;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      imgRef.current,
      completedCrop.x * scaleX,
      completedCrop.y * scaleY,
      completedCrop.width * scaleX,
      completedCrop.height * scaleY,
      0,
      0,
      completedCrop.width,
      completedCrop.height
    );

    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        if (!blob) return;
        blob.name = "cropped_food_image.jpeg";
        resolve(blob);
      }, "image/jpeg");
    });
  };

  const handleSave = async () => {
    const croppedBlob = await generateCroppedImage();
    if (croppedBlob) {
      onSave(croppedBlob);
    }
  };

  return (
    <Modal
      title="Crop Item Image"
      visible={visible}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>,
        <Button key="save" type="primary" onClick={handleSave}>
          Crop & Save
        </Button>,
      ]}
      width={600}
    >
      <div style={{ textAlign: "center", background: "#f5f5f5", padding: "20px", borderRadius: "8px" }}>
        {imageSrc && (
          <ReactCrop
            src={imageSrc}
            crop={crop}
            onImageLoaded={onLoad}
            onComplete={(c) => setCompletedCrop(c)}
            onChange={(c) => setCrop(c)}
            style={{ maxWidth: "100%" }}
          />
        )}
        <div style={{ marginTop: "15px", color: "#8c8c8c" }}>
          <Icon type="info-circle" style={{ marginRight: "5px" }} />
          Drag the corners to adjust the crop area.
        </div>
      </div>
    </Modal>
  );
};

export default ImageCropperModal;
